<template>
  <div class="configurations">
    <div class="container-fluid">
      <div class="animated fadeIn">
        <form action="">
          <div class="card">
            <div class="card-body">
              <section class="card-body" :style="styleCardBody" :name="'container'">
                <b-modal v-model="showLoadingCMD" width="auto" trap-focus :destroy-on-hide="true" aria-role="dialog"
                  aria-modal :can-cancel="false">
                  <template #default="props">
                    <LoadingCMD @close="props.close" :CMD="cmd" :sendingCMDMessage="sendingCMDMessage"
                      :countDown="countDown" :JsonObject="obj" @ActionAfterCMDGetReport="afterCMDGetReport">
                    </LoadingCMD>
                  </template>
                </b-modal>
                <div class="width:100%">
                  <b-navbar v-if="true" style="position: static" id="navBar">
                    <template #brand v-if="false">
                      <b-navbar-item>
                        <img class="option__image" src="@/assets/siriuslogo.png" style="width: 90px; height: 25px" />
                      </b-navbar-item>
                    </template>

                    <template #start>
                      <!-- Navbar Reports -->
                      <template v-for="(report, idx) in reportsTab">
                        <b-navbar-dropdown :label="translate(getLabel(report.Name))" v-if="containsTab(report.Name, '')"
                          :key="idx" :name="report.Name">
                          <template v-for="(level, index) in report.Reports">

                            <b-nav-item-dropdown :text="translate(level.Text)"
                              v-if="containsTab(report.Name, level.Text) && (level.PrimaryType.ByPeriod || level.SubReports != null)"
                              :key="index">

                              <template v-for="(sub, index) in level.SubReports">
                                <b-dropdown-item
                                  @click.native="processShowModal(report.Name, sub.ReportName, changeSubReports(sub.ReportFileName).type, changeSubReports(sub.ReportFileName).subMenu)"
                                  v-if="level.SubReports != null" :key="index">{{
                                    translate(changeSubReports(sub.ReportFileName).name) }}
                                </b-dropdown-item>
                              </template>

                              <!-- Secondary Type -->
                              
                              <template>
                                <!-- Primary Type -->
                                <b-dropdown-item @click.native="processShowModal(report.Name, level.ReportName, 'byPeriod')"
                                  v-if="level.PrimaryType.ByPeriod">{{ translate("byPeriod") }}</b-dropdown-item>
                              </template>

                            </b-nav-item-dropdown>
                          </template>
                        </b-navbar-dropdown>
                      </template>
                      <!-- Navbar End -->
                    </template>
                    <template #end>
                      <b-navbar-item tag="div">
                        <div class="buttons">
                          <b-upload style="padding-top: 10px; padding-left: 10px" v-model="file" class="file-label"
                            accept=".pdf" type="is-text" v-if="false">
                            <span class="file-cta">
                              <b-icon class="file-icon" type="is-text" icon="upload"></b-icon>
                              <span class="file-label">Load PDF</span>
                            </span>
                          </b-upload>
                        </div>
                      </b-navbar-item>
                    </template>
                  </b-navbar>
                </div>

                <b-modal v-model="showModalExport" has-modal-card trap-focus :destroy-on-hide="true" aria-role="dialog"
                  aria-modal :can-cancel="false">
                  <form action="">
                    <div class="modal-card" style="width: 600px; height: 100%">
                      <header class="modal-card-head">
                        <p class="modal-card-title">
                          {{ translate("lblExport") }}
                        </p>
                        <button type="button" class="delete" @click.prevent="closeExportReport()" />
                      </header>
                      <section class="modal-card-body">
                        <b-modal v-model="showLoadingCMDExport" width="auto" trap-focus :destroy-on-hide="true"
                          aria-role="dialog" aria-modal :can-cancel="false">
                          <template #default="props">
                            <LoadingCMD @close="props.close" :CMD="cmd" :sendingCMDMessage="sendingCMDMessage"
                              :countDown="countDown" :JsonObject="objExport"
                              @ActionAfterCMDExportReport="afterCMDExportReport">
                            </LoadingCMD>
                          </template>
                        </b-modal>
                        <b-field>
                          <button class="btn btn-outline-secondary" disabled>
                            <i class="icons-lg0 icons-document-download" />
                          </button>
                          &nbsp;
                          <b-select :placeholder="translate('lblSelectType')" v-model="fileType" required expanded>
                            <option v-for="  typeFileValue   in   typeFile  " v-bind:value="typeFileValue"
                              :key="typeFileValue.id">
                              <span v-if="typeFileValue.id == typeFile.PDF.id">
                                {{ typeFile.PDF.name.toUpperCase() }}
                              </span>
                              <span v-if="typeFileValue.id == typeFile.XLS.id">
                                {{ typeFile.XLS.name.toUpperCase() }}
                              </span>
                              <span v-if="typeFileValue.id == typeFile.HTML.id">
                                {{ typeFile.HTML.name.toUpperCase() }}
                              </span>
                              <span v-if="typeFileValue.id == typeFile.DOC.id">
                                {{ typeFile.DOC.name.toUpperCase() }}
                              </span>
                            </option>
                          </b-select>
                        </b-field>
                        <b-field v-if="isElectronVar">
                          <button class="btn btn-outline-secondary" disabled>
                            <i class="icons-lg0 icons-usb" />
                          </button>
                          &nbsp;
                          <b-select :placeholder="translate('lblSelectDevice')" v-model="penDrive" required expanded>
                            <option v-for="  penDrive   in   penDriveList  " v-bind:value="penDrive" :key="penDrive">
                              {{ penDrive.Name }}
                            </option>
                          </b-select>
                          &nbsp;
                          <button class="btn btn-outline-secondary" @click.prevent="refreshPenDrive()">
                            <i class="icons-lg0 icons-sync" />
                          </button>
                        </b-field>
                        <footer class="modal-card-foot">
                          <b-button :label="translate('btnCancel')" icon-left=".icons-white icons-times" icon-pack="icons"
                            @click="closeExportReport()" />
                          <b-button @click="sendExport()" :disabled="disableSendExport()" :label="translate('btnOk')"
                            type="is-primary" icon-left=".icons-white icons-check" icon-pack="icons" />
                        </footer>
                      </section>
                    </div>
                  </form>
                </b-modal>

                <b-modal v-model="showModal" has-modal-card trap-focus :destroy-on-hide="true" aria-role="dialog"
                  aria-modal :can-cancel="false">
                  <form action="">
                    <div class="modal-card" style="width: 600px; height: 750px">
                      <header class="modal-card-head">
                        <p class="modal-card-title">
                          {{ translate("lblFilter") }}
                          <span v-if="subMenu != ''">[{{ subMenu }}]</span>
                        </p>
                        <button type="button" class="delete" @click="closeShowModal()" />
                      </header>
                      <section class="modal-card-body">
                        <b-modal v-model="showLoadingCMDFilter" width="auto" trap-focus :destroy-on-hide="true"
                          aria-role="dialog" aria-modal :can-cancel="false">
                          <template #default="props">
                            <LoadingCMD @close="props.close" :CMD="cmd" :sendingCMDMessage="sendingCMDMessage"
                              :countDown="countDown" :JsonObject="objReportFilter"
                              @ActionAfterCMDGetReport="afterCMDGetReport">
                            </LoadingCMD>
                          </template>
                        </b-modal>

                        <div v-if="showModalMessageFilter">
                          <Message type="is-danger" :message="errorMessageFilter" :isList="false" />
                        </div>
                        <br />
                        <div class="control">
                          <b-switch v-model="showFilterByPeriod"
                            v-if="subMenu != ''">{{ translate("byPeriod") }}</b-switch>
                        </div>
                        <div v-if="showFilterByPeriod">
                          <b-field :label="translate('lblSelectDate')">
                            <b-datepicker v-model="dates" range required :locale="locale"
                              :placeholder="translate('lblClickToSelect')" icon="calendar-today" trap-focus>
                            </b-datepicker>
                          </b-field>
                        </div>
                      </section>
                      <footer class="modal-card-foot">
                        <b-button :label="translate('btnCancel')" icon-left=".icons-white icons-times" icon-pack="icons"
                          @click="closeShowModal()" />
                        <b-button :label="translate('btnOk')"
                          :disabled="!showFilterByPeriod" type="is-primary"
                          icon-left=".icons-white icons-check" icon-pack="icons" @click="getReport()" />
                      </footer>
                    </div>
                  </form>
                </b-modal>
                <div class="topnav col mb-2" v-if="showModalReportHtml">
                  <a :href="'#'" target="_blank" title="Printer" @click.prevent="printReport()" v-if="!isElectronVar">
                    <i class="icons-1x icons-printer" style="left: -8px"></i>
                  </a>

                  <a href @click.prevent="showModalExport = true" title="Export" v-if="isElectronVar">
                    <i class="icons-1x icons-printer-wireless" style="left: -8px"></i></a>

                  <a href @click.prevent="showModalExport = true" title="Download" v-else>
                    <i class="icons-1x icons-document-download" style="left: -8px"></i></a>
                  <a href @click.prevent="refreshReport()" title="Refresh Report">
                    <i class="icons-1x icons-sync" style="left: -8px; font-size: 27px"></i></a>
                </div>
                <section v-if="showModalReportHtml" id="section" :style="styleFile">
                  <template>
                    <div id="divImg" style="height: 100px;">
                      <pdf ref="pdfDoc" v-for="index in numPages" :key="index" :src="b64" :page="index"
                        style="display: block; width: 60%;margin-left: 18%;"></pdf>
                    </div>
                  </template>
                </section>
              </section>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Socket from "@/config/webSocket.js";
import SocketDriver from "@/config/webSocketDriver.js";
import en from "@/mixins/languages/en.js";
import es from "@/mixins/languages/es.js";
import nor from "@/mixins/languages/nor.js";
import swe from "@/mixins/languages/swe.js";
import notify from "@/config/notify.js";
import LoadingCMD from "@/components/processCMD/LoadingCMD";
import ReportName from "@/js/ReportsName.js";
import Message from "@/components/message/Message.vue";
import { countries } from "@/mixins/countryCode.js";
import { clientCommands } from "@/js/ClientCommands.js";
import { mapState } from "vuex";
import { typeFile, typeFilter } from "@/mixins/enums";
import { getSize } from "@/js/screenAdjustment.js";
import pdf from 'vue-pdf'
export default {
  name: "ManagerReport",
  mixins: [en, es, nor, swe],
  computed: mapState([
    "listIps",
    "showReportManager",
    "userLogged",
    "userLoggedTemp",
    "dataModule",
    "lang",
    "locale",
    "isElectronVar",
    "IP",
    "currentTab",
    "isFBM",
    "operatorName"
  ]),
  components: { LoadingCMD, Message, pdf },
  data() {
    return {
      numPages: 0,
      showModal: false,
      userReport: {},
      loaded: false,
      selected: new Date(),
      dates: [],
      user: undefined,
      cashier: undefined,
      sessionId: 0,
      machineList: [],
      subMenu: "",
      fromMachineList: false,
      //locale: this.locale, // Browser locale
      selectAll: false,
      iframe: {
        src: window.location.href,
        style: null,
        wrapperStyle: null,
      },
      obj: {
        ReportSection: "",
        ReportName: "",
        ReportType: "",
        ReportData: {
          InitialDate: "",
          FinalDate: "",
          SessionId: 0,
          MachineList: [],
          CashierId: 0,
          UserLogin: "",
        },
      },
      objBackup: {},
      objReportFilter: {},
      sessionData: [],
      terminalsData: [],
      cashierData: [],
      file: "",
      countDown: 60,
      sendingCMDMessage: "",
      cmd: "",
      showLoadingCMDFilter: false,
      showLoadingCMD: false,
      htmlcontent: "",
      showFilterByPeriod: false,
      byCurrentSession: false,
      showModalReportHtml: false,
      showModalExport: false,
      showLoadingCMDExport: false,
      typeFile: typeFile,
      showModalMessageFilter: false,
      errorMessageFilter: "",
      penDriveList: [],
      penDrive: null,
      fileType: null,
      objExport: {},
      b64: undefined,
      styleFile: "",
      reportFileName: "",
      styleCardBody: "width: 100%; height: 100%; overflow-y: hidden !important;",
      intervalGetDatas: null,
      countries: countries,
      reportsTab: [],
      cashierUsers: [],
      operatorNameAux: this.operatorName,
    };
  },
  props: {
    operator: String,
  },
  methods: {
    translate(prop) {
      return this[this.lang][prop];
    },
    reportTranslateName(name) {
      return ReportName.translateName(name, this.lang);
    },
    compare(a, b) {
      if (a.Index > b.Index)
        return 1;
      if (a.Index < b.Index)
        return -1;
      return 0;
    },
    orderReportTabs(reportsTab) {
      reportsTab.sort(this.compare);

      for (let i = 0; i < this.reportsTab.length; i++) {
        reportsTab[i].Reports.sort(this.compare);
      }
    },
    getLabel(nameLabel) {
      let name = nameLabel;
      let fbm = this.isFBM;

      switch (nameLabel) {
        case "Progressive":
          if (!fbm) {
            name = nameLabel + "DNG";
          }
          break;
        case "Mystery":
          if (!fbm) {
            name = "MannyBucks";
          }
          break;
      }
      return "lbl" + name;
    },
    changeSubReports(name) {
      let obj = {
        name: '',
        type: '',
        subMenu: ''
      };
      switch (name) {
        case "ProgressiveIncrement":
          obj.name = "detailed";
          obj.type = "";
          obj.subMenu = "Detailed";
          break;
        case "ProgressiveIncrementSummary":
          obj.name = "summary";
          obj.type = "byPeriod";
          obj.subMenu = "";
          break;
        case "BillInSummaryReport":
          obj.name = "summary";
          obj.type = "";
          obj.subMenu = "Summary";
          break;
        case "BillInHistReport":
          obj.name = "hist";
          obj.type = "";
          obj.subMenu = "Hist";
          break;
      }
      return obj;
    },

    sampleFormat(data) {
      return data.toLocaleDateString("pt-BR", data);
    },
    closeModal() {
      Socket.send(clientCommands.FinishGetReport.name + "|" + "");
      this.$store.commit("showReportManagerOptions", false);
      this.$emit("close");
    },
    getData() {
      Socket.send(clientCommands.ReportManagerData.name + "|" + "");
    },
    setData(data) {
      this.sessionData = data.SessionData;
      this.terminalsData = data.TerminalData;
      this.cashierData = data.CashierData;
    },
    refreshReport() {
      this.obj = JSON.parse(JSON.stringify(this.objBackup));
      this.showLoadingCMD = true;
      this.sendingCMDMessage =
        this.obj.ReportSection +
        " [" +
        this.obj.ReportName +
        "]";
      this.cmd = clientCommands.GetReport.name;

      this.showReportFile("", false);
    },
    processShowModal(section, name, type, subMenu = "") {
      try {
        this.obj.ReportSection = section;
        this.obj.ReportName = name;
        this.obj.ReportType = type;
        this.subMenu = subMenu;

        if (this.obj.ReportType == typeFilter.byPeriod) {
          this.showFilterByPeriod = true;
        } 
        this.showModal = true;
      } catch (e) {
        console.log("Error in processShowModal() " + e);
      }
    },

    sendCurrent(section, name, type, subMenu = "", levelText) {
      this.obj.ReportSection = section;
      this.obj.ReportName = name;
      this.obj.ReportType = type;
      if (subMenu != "") {
        this.obj.ReportType += "#" + subMenu;
      }
      this.cmd = clientCommands.GetReport.name;
      this.sendingCMDMessage =
        this.obj.ReportSection +
        " [" +
        this.obj.ReportName +
        "]";
      this.countDown = clientCommands.GetReport.time;
      this.showLoadingCMD = true;
      this.objBackup = JSON.parse(JSON.stringify(this.obj));
      this.showReportFile("", false);
      this.closeDropDownAfterClick(levelText);
      this.resetScrollBar();

    },
    closeShowModal() {
      this.showModalMessageFilter = false;
      this.errorMessageFilter = "";
      this.obj.ReportSection = "";
      this.obj.ReportName = "";
      this.obj.ReportType = "";
      this.obj.ReportData = {
        InitialDate: "",
        FinalDate: "",
        SessionId: 0,
        MachineList: [],
        UserLogin: "",
        CashierId: 0,
      };
      this.objReportFilter = {};
      this.dates = [];
      this.sessionId = 0;
      this.user = undefined;
      this.cashier = undefined;
      this.machineList = [];
      this.showModal = false;
      this.showFilterByPeriod = false;
      this.selectAll = false;
      this.subMenu = "";
      this.byCurrentSession = false;
    },

    checkFilter() {
      let ret = true;
      if (this.showFilterByPeriod && this.dates.length == 0) {
        ret = false;
      }
      return ret;
    },
    getReport() {
      try {    
        this.showModalMessageFilter = false;
        this.errorMessageFilter = "";
        
        if (this.checkFilter()) {
          this.objReportFilter = JSON.parse(JSON.stringify(this.obj));
          if (this.showFilterByPeriod) {
            this.objReportFilter.ReportData.InitialDate =
              this.sampleFormat(this.dates[0]) + " " + "00:00:00";
            this.objReportFilter.ReportData.FinalDate =
              this.sampleFormat(this.dates[1]) + " " + "23:59:59";
          } 
           else if (this.showFilterByPeriod) {
              this.objReportFilter.ReportType = typeFilter.byPeriod;
            }
          this.objReportFilter.ReportData.Operator = this.operatorName;
          this.cmd = clientCommands.GetReport.name;
          this.sendingCMDMessage =
            this.objReportFilter.ReportSection +
            " [" +
            this.objReportFilter.ReportName +
            "]";
          this.countDown = 60;
          this.showLoadingCMDFilter = true;
          this.objBackup = JSON.parse(JSON.stringify(this.objReportFilter));
          this.showReportFile("", false);

        } else {
          this.showModalMessageFilter = true;
          this.errorMessageFilter = this.translate("checkFieldsReport");
        }
      } catch (e) {
        console.log("Error in getReport()" + e);
      }
    },
    afterCMDGetReport(data) {
      try {
        if (data.object != null) {
          this.showReportFile(data.object.ReportData, true);
          this.showModal = false;
          this.penDriveList = data.object.PenDriveList;
          this.reportFileName = data.object.ReportName;
          this.closeShowModal();
        } else {
          notify.message(
            "foo",
            "Error",
            "[" + this.translate("messageErrorGetReport") + "]",
            "error",
            2000
          );
        }
      } catch (e) {
        console.log("Error in afterCMDGetReport() " + e);
      }
    },
    closeExportReport() {
      this.showModalExport = false;
      this.penDrive = null;
      this.fileType = null;
    },
    refreshPenDrive() {
      this.closeExportReport()
      this.refreshReport()
    },
    showHTML(data, show) {
      if (show) {
        document.getElementById("divImg").innerHTML =
          '<object type="text/html" data="' +
          data +
          '" style="width: 100%;height: calc(80vh - 142px - 75px);max-height: calc(80vh - 142px - 75px);""></object>';
      } else {
        document.getElementById("divImg").innerHTML = "";
      }
      this.showModalReportHtml = show;
    },
    printReport() {
      try {
        this.$refs.pdfDoc[0].print()
      } catch (e) {
        console.log("Error in printReport " + e);
      }
    },
    showReportFile(data, show) {
      if (show) {
        this.styleFile = "background-color: #525659; width: 100%;height: calc(80vh - 142px - 75px);max-height: calc(80vh - 142px - 75px);overflow:auto";
        this.b64 = pdf.createLoadingTask(this.convertDataURIToBinary(data));
        this.b64.promise.then(pdf => {
          this.numPages = pdf.numPages;
        });
      } else {
        this.b64 = undefined;
        this.styleFile = "";
      }
      this.showModalReportHtml = show;
    },
    convertDataURIToBinary(base64) {
      var raw = window.atob(base64);
      var rawLength = raw.length;
      var array = new Uint8Array(new ArrayBuffer(rawLength));

      for (var i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
      return array;
    },
    containsTab(tab, subTab) {
      let ret = false;
      let obj = null;

      console.log(this.userReport.Level)
      try {
        this.dataModule.reportLevels.forEach((report) => {
          if (report.Name === this.userReport.Level) {
            obj = report;
            obj = report.Categories.find((item) => item.Name == tab)?.Reports;
          }
        });

        if (obj != null) {
          if (obj !== undefined) {
            obj.forEach((x) => {
              if (x.Value && x.Visible) {
                if (subTab === "" || x.Text === subTab) {
                  ret = x.Value;
                }
              }
            });
          }
        }
      } catch (e) {
        console.log("Error in containsTabReportManager [" + tab + "]" + e.message);
      }

      return ret;
    },
    disableSendExport() {
      if (this.isElectronVar) {
        return this.penDrive == null || this.fileType == null;
      } else {
        return this.fileType == null;
      }
    },
    sendExport() {
      try {
        this.objExport = {
          ReportExtension: this.fileType.id,
          Location: this.isElectronVar ? this.penDrive.Location : "",
        };
        this.cmd = clientCommands.ExportReport.name;
        this.sendingCMDMessage = this.translate("messageExportReport");
        this.countDown = clientCommands.ExportReport.time;
        this.showLoadingCMDExport = true;
      } catch (e) {
        console.log("Error in sendExport() + " + e);
      }
    },
    processDownloadFile(obj) {
      try {
        this.objExport = obj;
        this.objExport.isDownload = true;
        this.obj.item = {};
        this.obj.method = "GET";
        this.cmd = clientCommands.ExportReport.name;
        this.showLoadingCMDExport = true;
        this.sendingCMDMessage = obj.message;
      } catch (e) {
        console.log("Error in ProcessDownloadFile(ManagerReport)" + e);
      }
    },
    afterCMDExportReport() {
      this.closeExportReport();
      this.showLoadingCMDExport = false;
    },
    closeDropDownAfterClick(levelReport) {
      var elementoNavBarActive = document.getElementsByName(levelReport);
      if (elementoNavBarActive != null && elementoNavBarActive.length > 0) {
        var navbarElement = elementoNavBarActive[0];
        navbarElement.classList.remove("is-active");
        setTimeout(() => {
          navbarElement.click();
        }, 500);
      }

    },
    resetScrollBar() {
      var containerRef = document.getElementsByName("container");
      if (containerRef != null && containerRef.length > 0) {
        containerRef[0].addEventListener('scroll', this.handleScroll);
        containerRef[0].scrollLeft = 0;
      }

    },
  },
  mounted() {
    //
  },
  beforeDestroy() {
    console.log("/Close - mountedDataReports()");
    clearInterval(this.intervalGetDatas);
  },
  created() {
    if (this.userLoggedTemp.Login == undefined) {
      this.userReport = JSON.parse(JSON.stringify(this.userLogged));
    } else {
      this.userReport = JSON.parse(JSON.stringify(this.userLoggedTemp));
    }

    SocketDriver.$on("finishedCMDReportManagerData", this.setData);
    //this.getData();
    this.reportsTab = [];

    let nivel = this.dataModule.reportLevels.filter((item) => {
      return item.Name === item.Name;
    });

    nivel.forEach((level) => {
      level.Categories.forEach((categoria) => {
        if (this.reportsTab.filter(i => { return i.Name === categoria.Name }).length == 0) {
          this.reportsTab.push(categoria);
        }
      })
    });

    this.orderReportTabs(this.reportsTab);

    this.intervalGetDatas = setInterval(() => {
      try {
        if (this.currentTab != "ReportManager") {
          console.log("/closed Report()");
          clearInterval(this.intervalGetDatas);
          return;
        }

        const screen = getSize();
        if (screen.width > 1050) {
          this.styleCardBody = "width: 100%; height: 100%; overflow-y: hidden !important;"
        } else {
          this.styleCardBody = "width: 100%; height: 100%; overflow-y: auto !important;"
        }
      } catch (e) {
        console.log("Error in ReportManager() " + e);
        
        if (this.currentTab != "Report") {
          console.log("/closed Report()");
          clearInterval(this.intervalGetDatas);
        }
      }
    }, 300);


  },
  watch: {
    file: function (val) {
      this.iframe.src = val.path;
    },
    selectAll: function (val) {
      if (val) {
        this.machineList = [];
        this.terminalsData.forEach((machine) => {
          this.machineList.push(machine);
        });
      } else {
        if (!this.fromMachineList) {
          this.machineList = [];
        }
      }
      this.fromMachineList = false;
    },
    operatorName(operator){
      if(this.operatorNameAux != operator){
        this.operatorNameAux = operator;
        this.showModalReportHtml = false;
      }
    }
  },
};
</script>
<style scoped src="@/css/styleModules.css">.dropdown+.dropdown {
  margin-left: 0;
}</style>
